/*
 * @Author: wumao
 * @Date: 2022-04-04 13:42:25
 * @LastEditors: wumao
 * @LastEditTime: 2022-04-06 17:30:23
 * @Description: 加解密工具
 */
import CryptoJS from 'crypto-js'

function toSignStrMap(params) {
  if (!params) {
    return ''
  }
  const keysList = []
  const keySet = Object.keys(params)
  keySet.sort()
  keySet.forEach((key) => {
    if (params[key]) {
      keysList.push(key)
    }
  })
  let res = ''
  keysList.forEach((key, index) => {
    if (index > 0) {
      res += '&'
    }
    res += `${key}=${params[key]}`
  })
  return res
}

function getJsonBySignStrMap(data) {
  const params = {}
  const split = data.split('&')
  split.forEach((str) => {
    const tmp = str.split('=')
    params[tmp[0]] = tmp[1]
  })
  return params
}

export function encrypt(params, appKey, appSecret) {
  if (typeof params !== 'object') {
    return
  }
  let data = toSignStrMap(params)
  const timestamp = new Date().getTime()
  data += timestamp
  const encrypt = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(appSecret), {
    iv: CryptoJS.enc.Utf8.parse(appKey),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return {
    params,
    appKey,
    timestamp,
    sign: encrypt.toString()
  }
}

export function decrypt(sign, timestamp, appKey, appSecret) {
  const decrypt = CryptoJS.AES.decrypt(sign, CryptoJS.enc.Utf8.parse(appSecret), {
    iv: CryptoJS.enc.Utf8.parse(appKey),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptMsg = decrypt.toString(CryptoJS.enc.Utf8)
  const result = decryptMsg.slice(0, decryptMsg.indexOf(timestamp))
  return getJsonBySignStrMap(result)
}
